// OAuth configuration utility
import { oauthEnabled } from '../aws-config';

export const getOAuthStatus = () => {
  return {
    enabled: oauthEnabled,
    environment: process.env.NODE_ENV,
    providers: oauthEnabled ? ['Google', 'Facebook', 'Apple', 'Microsoft'] : [],
    reason: oauthEnabled ? 'OAuth providers enabled' : 'OAuth providers disabled (pending third-party approval)'
  };
};

// Debug function for browser console
window.checkOAuthConfig = () => {
  const status = getOAuthStatus();
  console.log('=== OAUTH CONFIGURATION ===');
  console.log('Enabled:', status.enabled);
  console.log('Environment:', status.environment);
  console.log('Available providers:', status.providers);
  console.log('Status:', status.reason);
  console.log('Environment variable REACT_APP_OAUTH_ENABLED:', process.env.REACT_APP_OAUTH_ENABLED);
  return status;
};

export default { getOAuthStatus };